module.exports = __webpack_public_path__ + "img/collaboration.d734cae1.png";